import "./themes/fonts.css"; // Speedee @font-face before any UI CSS that references the family
import "./styles/global.scss";
import logger from "@services/logger";
import "@mcd/inpl-web-components/dist/themes/light.css";
import "./themes/light.css"; // must come after web-components theme to override design tokens (colors, spacing, shadows, radii, etc.) with app-specific values
import "flag-icons/css/flag-icons.min.css";
import { setBasePath } from "@mcd/inpl-web-components/dist/component-library.js";
import { env } from "@utils/env";
// Configure the base path for web components to load assets (icons, etc.)
const basePath = env.PUBLIC_PATH.endsWith("/")
    ? env.PUBLIC_PATH.slice(0, -1)
    : env.PUBLIC_PATH;
setBasePath(basePath);
logger.info(`Web components base path set to: ${basePath}`);
// Ensure shared dependencies are loaded before starting single-spa
async function init() {
    try {
        await import("./root-config");
    }
    catch (err) {
        logger.error("Error bootstrapping application:", err);
    }
}
init();
